// extracted by mini-css-extract-plugin
export default {"wrapper":"L46HbI","link-wrapper":"iZzvSd"};